<template>
    <tr class="angebot--item my-5" :key="Angebot.persistence_object_identifier">
        <td class="cursor-pointer" v-on:click="openVermieter"><template v-if="Angebot.name" >{{ Angebot.name }}</template><template v-else>-</template></td>
        <td>{{ Angebot.zimmergroesse }}m²</td>
        <td><span v-for="art in arten" v-bind:key="art.value"><span v-if="art.value == Angebot.zimmerart">{{ art.text}}</span></span></td>
        <td>{{ Angebot.ort }}</td>
        <td><template v-if="Angebot.freiab != '0000-00-00 00:00:00'">{{ Angebot.freiab  | date("DD.M.YYYY") }}</template></td>
        <td><template v-if="Angebot.freibis != '0000-00-00 00:00:00'">{{ Angebot.freibis  | date("DD.M.YYYY") }}</template></td>

        <td><a v-on:click="openModal(Angebot.persistence_object_identifier)"><mdb-icon icon="info-circle" /></a></td>
        <td><router-link class="angebot-link" :to="{name: 'angebotBearbeiten', params: {angebotToEdit: Angebot, id: Angebot.persistence_object_identifier}}"><mdb-icon icon="edit" /></router-link></td>

        <td><a v-on:click="acceptAngebot(Angebot.persistence_object_identifier)"><mdb-icon icon="check-circle" /></a></td>
        <td><a v-on:click="declineAngebot(Angebot.persistence_object_identifier)"><mdb-icon icon="times-circle" /></a></td>
        <td><a v-on:click="deactivateAngebot(Angebot.persistence_object_identifier)"><mdb-icon icon="times-circle" /></a></td>
        <td><a v-on:click="openKommentar(Angebot.persistence_object_identifier)"><mdb-icon icon="edit" /></a></td>
        <td><a v-on:click="openKommentarVorhanden(Angebot.persistence_object_identifier)"><mdb-icon icon="info" /></a></td>

        <!--<td>
            <a v-on:click="removeMerkliste()" v-if="isAufMerkliste">
                <mdb-icon fas icon="star" />
            </a>
            <a v-on:click="aufMerkliste()" v-else>
                <mdb-icon far icon="star" />
            </a>
        </td>-->
        <div class="kommentar__dimmer" v-if="kommentarAktiv"></div>
        <div class="kommentar__field" v-if="kommentarAktiv">
            <mdb-input type="textarea" v-model="kommentar" :rows="10" placeholder="Kommentar für Vermieter"></mdb-input>
            <div class="d-flex justify-content-between">
                <mdb-btn color="primary" @click.native.prevent="closeKommentar">Schließen</mdb-btn>
                <mdb-btn color="primary" @click.native.prevent="setEditAngebot(selectedAngebot)">Speichern</mdb-btn>
            </div>
        </div>
        <!--<Show :settings="settings" :Angebot="Angebot" :modalActive="modalActive" :isAufMerkliste="isAufMerkliste" :listOrte="listOrte" :lightbox="lightbox"></Show>-->
        <!--<Lightbox :Images="lightboxImages" :lightbox="lightbox"></Lightbox> -->
    </tr>

</template>

<script>
    import Show from "@/components/angebot/admin/Show";
    import { bus } from '@/main';
    //import settings from '@/components/Settings.json';
    import AngebotService from "@/services/AngebotService";
    import UserService from "@/services/UserService";
    import EmailService from "@/services/EmailService";
    import { mdbBtn, mdbInput, mdbDatePicker, mdbSelect, mdbSelectOption, mdbProgress } from 'mdbvue';
    import Lightbox from "@/components/Lightbox";
    import { mapGetters } from 'vuex'
    export default {
        name: "AngebotItem",
        components: {
            Show,
            mdbBtn,
            mdbInput,
            mdbDatePicker,
            mdbSelect,
            mdbSelectOption,
            mdbProgress,
            Lightbox
        },
        data() {
            return {

                arten: [],
                modalActive: false,
                isSelected: false,
                kommentarAktiv: false,
                kommentar: "",
                selectedAngebot: "",
                lightbox: false,
                lightboxImages: []
            };
        },
        props: {
            Angebot: Object,
            user: Object,
            isAufMerkliste: false,
            settings: Object,
        },
        methods:{
            openVermieter(){
              console.log("Open Vermieter")
              UserService.searchVermieter(this.Angebot.vermieter, 2).then(response =>{
                console.log(response)
                this.$router.push({ name: 'benutzerverwaltung-single', params: { user: response.data[0], type: 2 } })
              })
            },
            toggleLightbox(images){

                this.lightbox = !this.lightbox;
                this.lightboxImages = images;
            },
            closeKommentar(){
                this.kommentarAktiv = false;
                this.kommentar = "";
                this.selectedAngebot = "";
            },
            openKommentarVorhanden(id){
                this.kommentarAktiv = true;
                this.kommentar = this.Angebot.kommentar;
                this.selectedAngebot = id;
            },
            openKommentar(id){
                this.kommentarAktiv = true;
                this.kommentar = "";
                this.selectedAngebot = id;
            },
            openModal(){
                bus.$emit('openModal', this.Angebot);
            },
            closeModal(){
                this.modalActive = false;
            },
            selectOrt(key) {
                if(!key){return}
                key = key.replace(/ /g,'');
                this.places.forEach(option => {
                    if(option.value == key || option.text == key){
                        option.selected = true;
                        this.Angebot.ort = option.text;
                    }
                });
            },
            aufMerkliste(){
                    AngebotService.addAngebotToMerkliste(this.Angebot.persistence_object_identifier, this.user.persistence_object_identifier).then(response => {
                        this.$notify.success({
                            position: 'top right',
                            message: this.$t("Global.Merkliste.Added"),
                            timeout: 3000
                        });
                        this.$store.dispatch("updateMerkliste", this.user.persistence_object_identifier);
                        this.isAufMerkliste = true;
                    }).catch(error => {
                        console.log("There was an error:", error.response);
                    });


            },
            removeMerkliste(){
                    AngebotService.removeMerkliste(this.Angebot.persistence_object_identifier, this.user.persistence_object_identifier).then(response => {
                        this.$store.dispatch("updateMerkliste", this.user.persistence_object_identifier);
                        //this.$parent.emitChangeMerkliste();
                        this.$notify.warn({
                            position: 'top right',
                            message: 'Das Angebot wurde von Ihrer Merkliste entfernt.',
                            timeout: 3000
                        });

                    }).catch(error => {
                        console.log("There was an error:", error.response);
                    });


            },
        //executing the show method of child
        acceptAngebot(angebot){
            AngebotService.setAngebotStatus(angebot, "freigegeben", 1).then(response => {

                AngebotService.setAngebotStatus(angebot, "abgelehnt", 0).then(response => {

                    AngebotService.setAngebotStatus(angebot, "aktiv", 1).then(response => {

                        AngebotService.setAngebotStatus(angebot, "zur_bearbeitung", 0).then(response => {
                            this.$parent.emitChange();

                            this.$notify.success({
                                position: 'top right',
                                message: 'Das Wohnugsangebot wurde freigegeben.',
                                timeout: 3000
                            });
                            EmailService.sendMail("AngebotFreischaltung", "Ihr Angebot wurde Freigeschalten", this.Angebot.vermieter);

                        }).catch(error => {
                            console.log("There was an error:", error.response);
                        });

                    }).catch(error => {
                            console.log("There was an error:", error.response);
                        });

                }).catch(error => {
                        console.log("There was an error:", error.response);
                    });

            }).catch(error => {
                    console.log("There was an error:", error.response);
                });
        },
        declineAngebot(angebot){
            AngebotService.setAngebotStatus(angebot, "abgelehnt", 1).then(response => {
                //EmailService.sendMail("AngebotAblehnung", "Ihr Angebot wurde Abgelehnt", this.Angebot.vermieter);
                this.$parent.emitChange();
                this.$notify.warn({
                    message: "Das Wohnugsangebot wurde abgelehnt.",
                    position: 'top right',
                    timeout: 3000
                });

            }).catch(error => {
                console.log("There was an error:", error.response);
            });

        },
        deactivateAngebot(angebot){
          AngebotService.setAngebotStatus(angebot, "aktiv", 0).then(response => {
            EmailService.sendMail("AngebotDeaktiviert", "Ihr Angebot wurde deaktiviert", this.Angebot.vermieter);
            this.$parent.emitChange();
            this.$notify.warn({
              message: "Das Wohnugsangebot wurde auf inaktiv gesetzt.",
              position: 'top right',
              timeout: 3000
            });
          }).catch(error => {
            console.log("There was an error:", error.response);
          });
        },
        setEditAngebot(angebot){
            this.kommentarAktiv = false;
            AngebotService.setAngebotStatus(angebot, "freigegeben", 0).then(response => {

                AngebotService.setAngebotStatus(angebot, "abgelehnt", 0).then(response => {

                    AngebotService.setAngebotStatus(angebot, "aktiv", 1).then(response => {

                        AngebotService.setAngebotStatus(angebot, "kommentar_gesehen", 0);
                        AngebotService.setAngebotStatus(angebot, "zur_bearbeitung", 1, this.kommentar).then(response => {
                            this.$parent.emitChange();
                            this.$notify.success({
                                position: 'top right',
                                message: 'Das Wohnugsangebot wurde beim Vermieter zur bearbeitung beantragt.',
                                timeout: 3000
                            });


                        }).catch(error => {
                            console.log("There was an error:", error.response);
                        });

                    }).catch(error => {
                        console.log("There was an error:", error.response);
                    });

                }).catch(error => {
                    console.log("There was an error:", error.response);
                });

            }).catch(error => {
                console.log("There was an error:", error.response);
            });
            },
        },
        computed:{
          ...mapGetters([
            'places',
          ])
        },
        mounted: function () {
            this.arten = this.settings.Settings[1][this.$store.getters.lang][0].Zimmerarten;
            this.selectOrt(this.Angebot.ort);
        }
    }
</script>

<style scoped>
.cursor-pointer{
  cursor: pointer;
}
</style>